module.exports = __webpack_public_path__ + "img/2.438f6b75.png";